import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AuthGuard } from '@/routes/AuthGuard';
import { AccountShell } from '@/layouts/AccountShell';
import { ProjectGuard } from '@/routes/ProjectGuard';
import { ScopedPage } from '@/layouts/ScopedPage';
import { LoginPage } from '@/pages/auth/Login';
import { SignupPage } from '@/pages/auth/Signup';
import { ForgotPasswordPage } from '@/pages/auth/ForgotPassword';
import { ResetPasswordPage } from '@/pages/auth/ResetPassword';
import { ProjectsPage } from '@/pages/Projects';
import { WizardPage } from '@/pages/Wizard';
import { ProfilePage } from '@/pages/Profile';
import { UsersPage } from '@/pages/Users';
import { ModelConfigurationPage } from '@/pages/ModelConfiguration';
import { NotificationsPage } from '@/pages/Notifications';
import { PendingApprovalsPage } from '@/pages/PendingApprovals';
import { SlaReportPage } from '@/pages/SlaReport';
import { AuditLogPage } from '@/pages/AuditLog';
import { SettingsPage } from '@/pages/Settings';
import { NewRunPage } from '@/pages/NewRun';
import { DashboardPage } from '@/pages/Dashboard';
import { RunHistoryPage } from '@/pages/RunHistory';
import { RunDetailPage } from '@/pages/RunDetail';

export const routeDefinitions = [
  { path: '/login', element: <LoginPage /> },
  { path: '/signup', element: <SignupPage /> },
  { path: '/forgot-password', element: <ForgotPasswordPage /> },
  { path: '/auth/reset/:token', element: <ResetPasswordPage /> },

  {
    element: <AuthGuard />,
    children: [
      { index: true, element: <Navigate to="/p" replace /> },
      {
        element: <AccountShell />,
        children: [
          { path: 'p', element: <ProjectsPage />, handle: { crumb: 'Projects' } },
          { path: 'profile', element: <ProfilePage />, handle: { crumb: 'Profile' } },
          { path: 'notifications', element: <NotificationsPage />, handle: { crumb: 'Notifications' } },
          {
            path: 'pending-approvals',
            element: <PendingApprovalsPage />,
            handle: { crumb: 'Pending approvals' }
          },
          { path: 'sla-tat', element: <SlaReportPage />, handle: { crumb: 'SLA & TAT' } },
          { path: 'users', element: <UsersPage />, handle: { crumb: 'Users' } },
          {
            path: 'model-configuration',
            element: <ModelConfigurationPage />,
            handle: { crumb: 'Model configuration' }
          }
        ]
      },
      { path: 'projects/new', element: <WizardPage /> },
      { path: 'projects/new/:step', element: <WizardPage /> },
      {
        path: 'p/:projectSlug',
        element: <ProjectGuard />,
        children: [
          { index: true, element: <Navigate to="dashboard" replace /> },
          {
            path: 'dashboard',
            element: (
              <ScopedPage title="Pipeline runs">
                <DashboardPage />
              </ScopedPage>
            )
          },
          {
            path: 'runs',
            element: (
              <ScopedPage title="Run history">
                <RunHistoryPage />
              </ScopedPage>
            )
          },
          {
            path: 'runs/:runId',
            element: (
              <ScopedPage title="Run detail">
                <RunDetailPage />
              </ScopedPage>
            )
          },
          { path: 'new-run', element: <NewRunPage /> },
          { path: 'settings', element: <SettingsPage /> },
          { path: 'audit-log', element: <AuditLogPage /> }
        ]
      }
    ]
  },

  { path: '*', element: <Navigate to="/p" replace /> }
];

export const router = createBrowserRouter(routeDefinitions);
